const Loader = () => {
  
    return <div className="loader"><div className="loader__load"></div></div>
  }
  
  export default Loader